import React from "react";
import styles from "./ProgressBar.module.css";

const ProgressBar = ({ steps, currentStep, setCurrentStep }) => {
    return (
        <div className={styles.progressBarContainer}>
            {steps.map((step, index) => (
                <div key={index} className={styles.stepContainer}>
                    <div
                        className={
                            index < currentStep
                                ? styles.stepCompleted
                                : index === currentStep
                                    ? styles.stepCurrent
                                    : styles.stepPending
                        }
                    >
                        {index < currentStep
                            ? <i onClick={() => setCurrentStep(index)} class="fa-regular fa-circle-check fa-lg" />
                            : index === currentStep
                                ? <i className="fa-regular fa-circle-dot fa-lg"></i>
                                : <i className="fa-regular fa-circle fa-lg"></i>
                        }
                    </div>

                    <span
                        className={index < currentStep
                            ? styles.labelCompleted
                            : index === currentStep
                                ? styles.labelCurrent
                                : styles.labelPending
                        }
                    >
                        {step}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default ProgressBar;